<template>
  <div>
    <h1 class="text-center">Contact Us</h1>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <contact-vcard></contact-vcard>
      </div>
      <div class="col-xs-12 col-md-4">
        <telephone-box></telephone-box>
      </div>
      <div class="col-xs-12 col-md-4">
        <email-box></email-box>
      </div>
    </div>
    <hr />
    <contact-form></contact-form>
  </div>
</template>
<script>
import ContactVcard from "./contact/contact-vcard";
import TelephoneBox from "./contact/telephone-box";
import EmailBox from "./contact/email-box";
import ContactForm from "./contact/contact-form";
export default {
  name: 'contact',
  components: { ContactForm, EmailBox, TelephoneBox, ContactVcard }
}
</script>